<template>
  <main class="main page-inside text-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title">{{ $t(`Contacts`) }}</div>
        </div>
      </div>
      <div class="section contact-section">
        <img src="./../images/believe-peace.svg" class="img peace" />
        <div class="title">{{ $t(`Have a question?`) }}</div>
        <div class="form-fields-wrapper">
          <label>
            <input type="text" :placeholder="$t('Name')" v-model="name" />
          </label>
          <label>
            <input type="text" :placeholder="$t('Surname')" v-model="surname" />
          </label>
          <label>
            <input
              type="email"
              :placeholder="$t('E-mail address')"
              v-model="email"
            />
          </label>
          <div class="phone-input-wrapper">
            <vue-tel-input
              v-if="allowedCountries.length > 0"
              v-model="phone"
              :only-countries="allowedCountries"
              :default-country="computedDefaultCountry"
              :auto-default-country="false"
              mode="international"
              :auto-format="true"
              :valid-characters-only="true"
              :dropdown-options="{
                showDialCodeInList: true,
                showDialCodeInSelection: false,
                showFlags: true,
                showSearchBox: false,
                tabindex: 0,
              }"
              :input-options="{
                placeholder: $t('Enter phone number'),
                disabled: allowedCountries.length === 0,
              }"
              @on-input="onPhoneInput"
              @blur="onPhoneBlur"
              class="contact-phone-input"
            />
            <input
              v-else
              type="tel"
              :placeholder="$t('Loading countries...')"
              disabled
              class="phone-loading-input"
            />
          </div>
          <label class="full">
            <input type="text" :placeholder="$t('Topic')" v-model="topic" />
          </label>
          <label class="full">
            <textarea :placeholder="$t('Message')" v-model="message"></textarea>
          </label>
          <button @click="contactSubmit" class="button">
            <span>{{ $t(`Send`) }}</span>
          </button>
          <transition name="fade">
            <div v-if="error" class="error-desc desc red">{{ error }}</div>
          </transition>
          <transition name="fade">
            <div v-if="successMessage" class="error-desc desc green">
              {{ successMessage }}
            </div>
          </transition>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "Contaacts",
  props: [],
  inject: ["openSignInModal"],

  components: {},

  data: function () {
    return {
      successMessage: "",
      error: "",
      name: "",
      surname: "",
      email: "",
      phone: "",
      topic: "",
      message: "",
      countryOptions: [],
      phoneFull: "",
      currentPhoneObject: null,
    };
  },

  computed: {
    allowedCountries() {
      return this.countryOptions && this.countryOptions.length > 0
        ? this.countryOptions.map((iso) => iso.toLowerCase())
        : [];
    },
    computedDefaultCountry() {
      if (this.allowedCountries.length > 0) {
        return this.allowedCountries[0];
      }
      return null;
    },
  },

  mounted() {
    this.getCountries();
  },

  methods: {
    getCountries() {
      this.$http
        .get("countries")
        .then((res) => {
          this.countryOptions = res.data.payload.map((obj) => obj.iso2);
        })
        .catch((res) => {
          if (res.response?.status === 401) {
            this.openSignInModal();
          }
        });
    },
    phoneDataUpdate(number, phoneObject) {
      this.phoneFull = phoneObject.formattedNumber || number;
    },
    onPhoneInput(number, phoneObject) {
      this.phone = number;
      this.phoneFull = phoneObject?.formattedNumber || number;

      // Store the phone object for later validation
      this.currentPhoneObject = phoneObject;

      // Clear any existing errors when user is typing
      this.error = "";
    },
    onPhoneBlur() {
      // Validate when user leaves the phone input field
      this.validateCurrentPhone();
    },
    validateCurrentPhone() {
      if (!this.currentPhoneObject) {
        return true;
      }

      const phoneObject = this.currentPhoneObject;

      // Only validate if user has entered something that looks like it could be a complete number
      if (
        phoneObject &&
        phoneObject.countryCode &&
        this.phone &&
        this.phone.length > 5
      ) {
        const countryCode = phoneObject.countryCode.toLowerCase();
        const isSupported =
          this.countryOptions && this.countryOptions.length > 0
            ? this.countryOptions.some(
                (iso) => iso && iso.toLowerCase() === countryCode
              )
            : false;

        if (!isSupported) {
          this.error = "This country is not supported";
          return false;
        }

        // Check if phone number is valid
        if (!phoneObject.valid) {
          this.error = "Please enter a valid phone number";
          return false;
        }
      }

      return true;
    },
    validatePhone(phoneObject) {
      // Check if phoneObject exists and has required properties
      if (!phoneObject) {
        return false;
      }

      // Check if the country is supported by our API
      if (phoneObject.countryCode) {
        const countryCode = phoneObject.countryCode.toLowerCase();
        const isSupported =
          this.countryOptions && this.countryOptions.length > 0
            ? this.countryOptions.some(
                (iso) => iso && iso.toLowerCase() === countryCode
              )
            : false;

        if (!isSupported) {
          return false;
        }
      }
      return phoneObject.valid || false;
    },
    contactSubmit() {
      // Validate phone before submission
      if (!this.validateFormBeforeSubmit()) {
        return;
      }

      let data = {
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phoneFull,
        topic: this.topic,
        message: this.message,
      };
      let self = this;
      this.$http
        .post("contact-us", data)
        .then((res) => {
          if (res.data.status == "OK") {
            self.error = "";
            self.successMessage = "Thank you!";
            setTimeout(function () {
              self.successMessage = "";
            }, 2000);
          } else {
            this.error = res.data.message;
          }
        })
        .catch((res) => {
          this.error =
            res.response?.data?.message || res.message || "An error occurred";
        });
    },
    validateFormBeforeSubmit() {
      // Clear any existing errors
      this.error = "";

      // Check if all required fields are filled
      if (!this.name || !this.surname || !this.email || !this.phone || !this.topic || !this.message) {
        this.error = this.$t('Please fill in all required fields');
        return false;
      }

      // Validate phone number
      if (!this.currentPhoneObject) {
        this.error = this.$t('Please enter a valid phone number');
        return false;
      }

      // Check if phone number is valid using our validation method
      if (!this.validatePhone(this.currentPhoneObject)) {
        this.error = this.$t('Please enter a valid phone number');
        return false;
      }

      // Check if phone number is actually valid (not just country supported)
      if (!this.currentPhoneObject.valid) {
        this.error = this.$t('Please enter a valid phone number');
        return false;
      }

      return true;
    },
  },
});
</script>

<style scoped>
.phone-input-wrapper {
  width: 100%;
}
</style>
